'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHECKBOX_SIZES = undefined;

var _enum = require('../../utils/enum');

var _enum2 = _interopRequireDefault(_enum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHECKBOX_SIZES = exports.CHECKBOX_SIZES = new _enum2.default({
  SMALL: {
    value: 'small',
    size: 12
  },
  MEDIUM: {
    value: 'medium',
    size: 14
  },
  LARGE: {
    value: 'large',
    size: 16
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/checkbox/constants.js
// module id = 312
// module chunks = 114276838955818